import {DefaultAuthUrls} from "../default-auth-urls.ts";
import {type UrlRule} from "../types.ts";

import {mapParam} from "./map-param.ts";

/**
 * Remove the continue param if the URL is an auth URL.
 *
 * This looks at the value of the given param, and if it is not present,
 * it will set the value of the param in the URL being constructed to the
 * given default value.
 *
 * This is useful for ensuring that required params have a value.
 *
 * @param paramName The name of the continue param. Defaults to "continue".
 * @param authUrls An array of regexes that match auth URLs. If the continue
 * param matches any of these URLs, it will be removed. This defaults to
 * `DefaultAuthUrls()`
 * @returns A URL rule that removes the continue param if the URL is
 * an auth URL.
 */
export const noContinueForAuthUrls = (
    paramName: string = "continue",
    authUrls: Array<RegExp> = DefaultAuthUrls(),
): UrlRule =>
    mapParam(paramName, (v) => {
        // If we're already continuing to a auth-related page, or the homepage,
        // we just ignore the result and don't add a continue path.
        if (v && authUrls.some((matcher) => matcher.test(v))) {
            return null;
        }
        return v;
    });
